export const priceProductsTableStructure = {
    massActions: [],
    headers: {
        centralId: {
            text: "ID",
            key: "centralId",
            type: "number",
            sortable: true,
            style: "cursor:pointer;width:5%",
        },
        name: {
            text: "Nazwa",
            key: "name",
            type: "text",
            sortable: true,
            style: "cursor:pointer;width:40%",
        }, // available types: number, string, date,datetime,array,boolean,actions,button
        bloz: {
            text: "Bloz",
            key: "bloz",
            type: "text",
            sortable: true,
            style: "cursor:pointer;width:10%",
        },
        ean: {
            text: "EAN",
            key: "ean",
            type: "text",
            sortable: true,
            style: "cursor:pointer;width:15%",
        },
        price: {
            text: "Cena",
            key: "price",
            type: "number",
            sortable: true,
            style: "cursor:pointer;width:10%",
        },
        taskCentralId: {
            text: "ID startegii",
            key: "taskCentralId",
            type: "number",
            sortable: true,
            style: "cursor:pointer;width:10%",
        },
        isStatic: {
            text: "Statyczny",
            key: "isStatic",
            type: "number",
            sortable: true,
            style: "cursor:pointer;width:10%",
        },



        actions: {
            text: "Akcje",
            key: "actions",
            type: "actions",
            style: "cursor:pointer;width:30%",
            visible: true,
            actions: [
                // {
                //     text: "Edytuj",
                //     icon: "edit",
                //     action: "edit",
                //     class: "btn btn-info table-actions-button edit-button",
                //     enabled: true,
                // },
                // {
                //     text: "Usuń",
                //     icon: "trash-alt",
                //     action: "delete",
                //     class: "btn btn-danger table-actions-button edit-button",
                //     enabled: true,
                // },
            ],
        },
    },
    data: [],
};
